import { jsxs as s, Fragment as g, jsx as i } from "react/jsx-runtime";
import { clsx as t } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useDisclosure as _ } from "../../../utils/use-disclosure.js";
import { RocheUIIcon as d } from "../../icon/roche-icon.js";
import e from "./roche-pipeline-changes-track-mobile-item.module.scss.js";
const v = ({
  name: r,
  indicationShort: c,
  phaseLabel: a,
  label: l,
  open: n = !1,
  onToggle: m,
  children: o
}) => {
  const { triggerProps: p, panelProps: h } = _(n);
  return /* @__PURE__ */ s(g, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: e["pipeline-changes-track-mobile-item__trigger"],
        onClick: () => m(!n),
        ...p,
        children: [
          a && /* @__PURE__ */ i("span", { className: e["pipeline-changes-track-mobile-item__visually-hidden"], children: a }),
          l && /* @__PURE__ */ i("span", { className: e["pipeline-changes-track-mobile-item__visually-hidden"], children: l }),
          /* @__PURE__ */ i("span", { className: e["pipeline-changes-track-mobile-item__name"], children: r }),
          c && /* @__PURE__ */ i("span", { className: e["pipeline-changes-track-mobile-item__indication"], children: c }),
          /* @__PURE__ */ i(
            "span",
            {
              className: t(
                e["pipeline-changes-track-mobile-item__toggle-icon"],
                n && e["pipeline-changes-track-mobile-item__toggle-icon--open"]
              ),
              children: /* @__PURE__ */ i(d, { icon: "chevron-down", height: "16px", decorative: !0 })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ i(
      "div",
      {
        className: t(
          e["pipeline-changes-track-mobile-item__panel"],
          n && e["pipeline-changes-track-mobile-item__panel--open"]
        ),
        ...h,
        children: /* @__PURE__ */ i("div", { className: e["pipeline-changes-track-mobile-item__panel-content"], children: o })
      }
    )
  ] });
};
export {
  v as RocheUIPipelineChangesTrackMobileItem
};
